import React, { useState } from 'react';

const LandingPage = ({ onAuthenticate, loading }) => {
  const [companyCode, setCompanyCode] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [questionnaireCode, setQuestionnaireCode] = useState('');
  const [showResumeMessage, setShowResumeMessage] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (companyCode.trim() && employeeName.trim() && questionnaireCode.trim()) {
      onAuthenticate(companyCode.trim(), employeeName.trim(), questionnaireCode.trim());
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card rounded-2xl p-8 w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/logos/DP LOGO - ON WHT.png" 
            alt="Dewpoint Group Logo" 
            className="h-16 w-auto"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold gradient-text mb-2">
            AI Maturity Assessment
          </h1>
          <h2 className="text-xl text-gray-600">
            Questionnaire
          </h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="companyCode" className="block text-sm font-medium text-gray-700 mb-2">
              Enter Company Code:
            </label>
            <input
              type="text"
              id="companyCode"
              value={companyCode}
              onChange={(e) => setCompanyCode(e.target.value)}
              className="input-field"
              placeholder="Company Code"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label htmlFor="employeeName" className="block text-sm font-medium text-gray-700 mb-2">
              Enter Employee Name:
            </label>
            <input
              type="text"
              id="employeeName"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
              className="input-field"
              placeholder="Employee Name"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label htmlFor="questionnaireCode" className="block text-sm font-medium text-gray-700 mb-2">
              Enter Employee Questionnaire Code:
            </label>
            <input
              type="text"
              id="questionnaireCode"
              value={questionnaireCode}
              onChange={(e) => setQuestionnaireCode(e.target.value)}
              className="input-field"
              placeholder="Questionnaire Code"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={loading || !companyCode.trim() || !employeeName.trim() || !questionnaireCode.trim()}
          >
            {loading ? 'Authenticating...' : 'Submit'}
          </button>
        </form>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-gray-500">
          <p>Please ensure all fields are completed accurately</p>
          <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-blue-700 text-xs">
              <strong>Note:</strong> You can save your progress at any time and return later to complete the assessment.
              Simply enter the same credentials to resume where you left off.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;